import { Drawer } from '@mui/material';
import styled from 'styled-components';

interface MainProps {
  $open: boolean;
  $width: number;
  $isLg: boolean;
}

const Main = styled.div<MainProps>`
  position: relative;
  flex-grow: 1;
  transition: ${({ theme, $open }) => theme.transitions.create(['margin', 'width'], {
    easing: $open ? theme.transitions.easing.sharp : theme.transitions.easing.easeOut,
    duration: $open ?
      theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
  })};
  margin-right: ${({ $open, $width, $isLg }) => (($open && $isLg) ? $width : 0)}px;
`;

interface SideBarProps {
  $width: number;
  $isLg: boolean;
  $fullPage: boolean;
}

const SideBar = styled(Drawer)<SideBarProps>`
  && {
    z-index: ${({ theme }) => theme.zIndex.drawer + 1};
    width: ${({ $width, $isLg, $fullPage }) => (($isLg || !$fullPage) ? `${$width}px` : '100%')};
    flex-shrink: 0;
  }
  .MuiDrawer-paper {
    padding: ${({ theme }) => theme.spacing(2)};
    width: ${({ $width, $isLg, $fullPage }) => (($isLg || !$fullPage) ? `${$width}px` : '100%')};
    box-sizing: border-box;
  }
`;

export { Main, SideBar };
